import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { Column, Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";
import {
  getIndexedValue,
  hasWriteAccess,
  searchMatchRule,
  doorVersionFilter,
  driveVersionFilter,
  escalatorVersionFilter,
  escalatorFaultVersionFilter,
  liftVersionFilter
} from "../../../utils/utils";
import ExcelExport from "../../../components/ExcelExport/ExcelExport";
import { EditActions, editActions } from "../../../actions/editActions";
import { ColumnActions, columnActions } from "../../../actions/columnActions";
import {
  isEditActiveSelector,
  editedObjectIdentifierSelector
} from "../../../reducers/editReducer";
import styles from "./ActionMenu.module.scss";
import ActionMenuButton from "../../../components/ActionMenuButton/ActionMenuButton";
import { Popup, Grid, Header, Divider } from "semantic-ui-react";
import GlobalTableSettings from "../../GlobalTableSettings/GlobalTableSettings";
import ColumnSelection from "../../../components/ColumnSelection/ColumnSelection";
import ProductVersionFilter from "../Filters/ProductVersionFilter";
import UserGroupFilter from "../Filters/UserGroupFilter";
import VersionFilter from "../Filters/VersionFilter";
import service from "../../../images/service-24.png";
import exportIcon from "../../../images/export.svg";
import add from "../../../images/circle-plus.svg";
import back from "../../../images/arrow-left-button.svg";
import { getGroupNameByDomainId, filterUserGroupParameters } from "../../../utils/pdApiUtils";
import {
  setGroupAPMParameterExtraProperties,
  setParameterExtraProperties
} from "../../../utils/pdApiUtils";

type StateProps = {
  pdApi: State.PdApi | undefined;
  columns: State.ColumnMap;
  mainState: State.Main;
  isEditActive: boolean;
  objectIdentifier: string;
};

type DispatchProps = {
  editActions: typeof editActions;
  columnActions: typeof columnActions;
};

type OwnProps = {
  subMenuRoute: State.AnySubMenu | State.AnyChildItem;
  groupName?: Api.GroupName;
  // eslint-disable-next-line @typescript-eslint/ban-types
  setExtraProperties: Function | null;
  // eslint-disable-next-line @typescript-eslint/ban-types
  createEmpty: Function;
  selectedColumnsName: keyof State.ColumnMap;
  dataFieldName: keyof State.PdApi | null;
  itemName: string;
  showExport?: boolean;
  showTableSettings?: boolean;
  columnFilters?: Filter[];
  filterOptions?: State.FilterOptions;
};

// Props of the component
export type ActionMenuProps = StateProps & DispatchProps & OwnProps;

export class ActionMenu extends React.Component<ActionMenuProps> {
  componentDidUpdate(prevProps: ActionMenuProps): void {
    if (prevProps.columnFilters !== this.props.columnFilters) {
      this.setState({
        filters: this.props.columnFilters
      });
    }
  }

  constructor(props: ActionMenuProps) {
    super(props);
    this.state = {
      filters: [] // or whatever initial value you need
    };
  }

  render(): JSX.Element {
    const {
      columns,
      pdApi,
      mainState,
      subMenuRoute,
      isEditActive,
      groupName,
      setExtraProperties,
      selectedColumnsName,
      dataFieldName,
      createEmpty,
      itemName,
      showExport,
      showTableSettings,
      filterOptions
    } = this.props;
    const groupAcess =
      groupName === "Group" && dataFieldName === "parameterCategories" ? false : true;
    if (!dataFieldName) {
      return <div>Error</div>;
    }
    let selectedColumns: State.Column[] = columns[selectedColumnsName];
    const domainGroupId: number | undefined = pdApi ? _.values(pdApi.domainGroups).find(
      (domainGroup: Api.DomainGroup) => domainGroup.enumName === groupName
    )?.id : undefined;
    if (domainGroupId || (groupName === "Lift" && dataFieldName === "faultComponents")) {
      selectedColumns = selectedColumns.filter(row => {
        if (groupName === "Lift" && dataFieldName === "faultComponents") {
          return row.name !== "Domain Group" && row.name !== "Domain";
        }
        return row.name !== "Domain Group";
      });
    }

    const { activeUser } = mainState;
    // eslint-disable-next-line
    const groupfault: boolean = groupName == "Group" && dataFieldName == "groupFaults";
    let selectedData: Api.AnyItem[];
    if (!pdApi) {
      selectedData = [];
    } else if (typeof pdApi[dataFieldName] === typeof Array) {
      selectedData = pdApi[dataFieldName] as State.PdApi[];
    } else {
      selectedData = _.values(pdApi[dataFieldName]);
    }
    if (selectedData.length > 0 && pdApi) {
      if (itemName === "fault" && groupName !== "Drive") {
        selectedData = selectedData.filter(
          fault => getGroupNameByDomainId(fault.domain.id, pdApi) === groupName
        );
      } else if (itemName === "fault" && groupName === "Drive") {
        selectedData = pdApi.driveFaults ? pdApi.driveFaults : [];
      } else if (itemName === "fault component" && domainGroupId) {
        selectedData = selectedData.filter(
          (row: Api.FaultComponentEnumeration) => row.domainGroup?.id === domainGroupId
        );
      } else if (itemName === "grand norm" && domainGroupId) {
        const liftDomainGroupEnumValue = pdApi.domainGroups[domainGroupId]?.enumValue;
        selectedData = selectedData.filter(
          (row: Api.GrandNorm) => row.domainGroupId === liftDomainGroupEnumValue
        );
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rows: Array<any> = !setExtraProperties
      ? selectedData
      : selectedData.map(row => setExtraProperties(row, pdApi));


    const onAddNewItemClick = () =>
      this.props.editActions.startEditing(createEmpty(pdApi, groupName, false), true);
    const filters =
      dataFieldName === "liftParameters" && groupName === "Lift" ? (
        <>
          <ProductVersionFilter filterTarget="kceProduct" />
          <ProductVersionFilter filterTarget="kceVersion" />
          <UserGroupFilter target="Lift" />
        </>
      ) : dataFieldName === "doorParameters" ? (
        <>
          <VersionFilter />
          <UserGroupFilter target="Door" />
        </>
      ) : dataFieldName === "driveParameters" ? (
        <ProductVersionFilter filterTarget="driveVersion" />
      ) : dataFieldName === "escalatorParameters" ? (
        <>
          <ProductVersionFilter filterTarget="escalatorVersion" />
          <UserGroupFilter target="Escalator" />
        </>
      ) : dataFieldName === "escalatorFaults" ? (
        <ProductVersionFilter filterTarget="escalatorVersion" />
      ) : null;

    let filteredRows = rows;
    if (selectedData.length > 0 && itemName === "parameter category") {
      filteredRows = filteredRows.filter(
        row => row.parentCategory === null && (!groupName || row.extraDomainGroupName === groupName)
      );
    }

    if (
      dataFieldName === "EscalatorEventTypes" &&
      pdApi?.EscalatorEventTypes &&
      pdApi?.EscalatorEventClasses &&
      filteredRows
    ) {
      filteredRows.forEach((row: Api.EventEnumeration) => {
        const eventClass = pdApi?.EscalatorEventClasses
          ? pdApi.EscalatorEventClasses.findIndex(
              (eventClass: Api.EventEnumeration) =>
                row.escalatorEventClassId === eventClass.enumValue
            )
          : -1;
        if (row.eventClassEnumName === "" && pdApi?.EscalatorEventClasses) {
          row.eventClassEnumName =
            eventClass === -1
              ? "None"
              : pdApi.EscalatorEventClasses[eventClass].enumName +
                " [" +
                pdApi.EscalatorEventClasses[eventClass].enumValue +
                "]";
        }
      });
    }
    if (filterOptions) {
      switch (dataFieldName) {
        case "doorParameters":
          filteredRows = doorVersionFilter(filteredRows, filterOptions.selectedDoorVersion);
          break;
        case "driveParameters":
          filteredRows = driveVersionFilter(filteredRows, filterOptions.selectedDriveVersion);
          break;
        case "escalatorParameters":
          filteredRows = escalatorVersionFilter(
            filteredRows,
            filterOptions.selectedEscalatorVersion
          );
          break;
        case "escalatorFaults":
          filteredRows = escalatorFaultVersionFilter(
            filteredRows,
            filterOptions.selectedEscalatorVersion
          );
          break;
        case "liftParameters":
          filteredRows = liftVersionFilter(filteredRows, filterOptions.selectedKceVersion);
          break;
      }

      if (dataFieldName === "liftParameters") {
        const filterBinding = (binding: Api.LiftParameterBinding) => {
          const hasProduct =
            filterOptions.selectedKceProduct === -1 ||
            binding.kceProduct.id === filterOptions.selectedKceProduct;
          const hasVersion =
            filterOptions.selectedKceVersion === -1 ||
            binding.kceVersion.id === filterOptions.selectedKceVersion;
          return hasProduct && hasVersion;
        };

        filteredRows = filteredRows.filter((parameter: Api.LiftParameter) =>
          filterOptions.selectedKceProduct === -1 && filterOptions.selectedKceVersion === -1
            ? true
            : !!parameter.liftParameterBindings?.find(binding => filterBinding(binding))
        );
      }
    }

    if (groupName === "APM" && dataFieldName === "apmParameters" && pdApi) {
      filteredRows = filteredRows.map(row =>
        setGroupAPMParameterExtraProperties(row as Api.ApmParamters, pdApi)
      );
    }

    if (dataFieldName === "driveParameters" && pdApi) {
      filteredRows = filteredRows.map(
        row => setParameterExtraProperties(row, pdApi) as Api.DriveParameter
      );
    }

    if (filteredRows.length > 0 && filterOptions) {
      if (dataFieldName === "liftParameters") {
        const filteredUserGroup =
          filterOptions.selectedUserGroup === -1
            ? filteredRows
            : filterUserGroupParameters(filteredRows, filterOptions.selectedUserGroup);
        filteredRows = filteredUserGroup;
      } else if (dataFieldName === "doorParameters") {
        const filteredUserGroup =
          filterOptions.selectedDoorUserGroup === -1
            ? filteredRows
            : filterUserGroupParameters(filteredRows, filterOptions.selectedDoorUserGroup);
        filteredRows = filteredUserGroup;
      } else if (dataFieldName === "escalatorParameters") {
        const filteredUserGroup =
          filterOptions.selectedEscalatorUserGroup === -1
            ? filteredRows
            : filterUserGroupParameters(filteredRows, filterOptions.selectedEscalatorUserGroup);
        filteredRows = filteredUserGroup;
      }
    }

    const tempFilter = filteredRows;

    const changedFilters = this.props.columnFilters
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        JSON.parse(JSON.stringify(this.props.columnFilters)).filter((obj: any) =>
          Object.prototype.hasOwnProperty.call(obj, "value")
        )
      : [];

    if (changedFilters.length > 0) {
      if (changedFilters.length === 1) {
        if (changedFilters[0].value === "all") {
          filteredRows = tempFilter;
        } else {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const index = changedFilters.findIndex((filter: any) => filter.id === "Category");
          const categoryFilter =
            index >= 0
              ? filteredRows.filter(
                  row => row.commonExtra?.categoryName === changedFilters[index].value
                )
              : [];
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const domainIndex = changedFilters.findIndex((filter: any) => filter.id === "Domain");
          const domainFilter =
            domainIndex >= 0
              ? filteredRows.filter(
                  row => row.commonExtra?.domainName === changedFilters[domainIndex].value
                )
              : [];
          if (categoryFilter.length == 0 && index >= 0) {
            filteredRows = tempFilter;
          } else if (domainFilter.length == 0 && domainIndex >= 0) {
            filteredRows = tempFilter;
          } else {
            filteredRows = this.filterWithUserSelection(changedFilters, tempFilter);
          }
        }
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const index = changedFilters.findIndex((filter: any) => filter.id === "Category");
        const categoryFilter =
          index >= 0
            ? filteredRows.filter(
                row => row.commonExtra?.categoryName === changedFilters[index].value
              )
            : [];

        if (categoryFilter.length === 0 && index >= 0) {
          changedFilters.splice(index, 1);
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const domainIndex = changedFilters.findIndex((filter: any) => filter.id === "Domain");
        const domainFilter =
          domainIndex >= 0
            ? filteredRows.filter(
                row => row.commonExtra?.domainName === changedFilters[domainIndex].value
              )
            : [];
        if (domainFilter.length == 0 && domainIndex >= 0) {
          changedFilters.splice(domainIndex, 1);
        }
        filteredRows = this.filterWithUserSelection(changedFilters, filteredRows);
      }
    }

    return (
      <div className={styles.AllActions}>
        {!!filters && <div className={styles.filters}>{filters}</div>}
        <div className={styles.ActionMenuWrapper}>
          {hasWriteAccess(activeUser, groupName) && dataFieldName === "iodataSections" && (
            <div className={styles.breadcrumb}>
              <ActionMenuButton id="back" onClick={() => this.props.editActions.toggleChildView()}>
                <img className={styles.icon} src={back} alt="Back to IO BASIC DATA TYPE" />
              </ActionMenuButton>
              <p className={styles.currentView}>I/O data sections</p>
            </div>
          )}

          {hasWriteAccess(activeUser, groupName) && dataFieldName === "ioOptionsEnumType" && (
            <div className={styles.breadcrumb}>
              <ActionMenuButton id="back" onClick={() => this.props.editActions.toggleChildView()}>
                <img className={styles.icon} src={back} alt="Back to IO Options" />
              </ActionMenuButton>
              <p className={styles.currentView}>I/O Options</p>
            </div>
          )}

          {showExport !== false &&
          filteredRows.length > 0 &&
          hasWriteAccess(activeUser, groupName) ? (
            <ActionMenuButton>
              <div className={styles.withIcon}>
                <img className={styles.icon} src={exportIcon} alt="Export to excel" />
                <ExcelExport
                  rows={filteredRows}
                  columns={selectedColumns}
                  filename={subMenuRoute}
                />
              </div>
            </ActionMenuButton>
          ) : (
            showExport !== false && (
              <ActionMenuButton>
                <div className={styles.withIcon}>
                  <img
                    className={`${styles.icon} ${styles.disableImg}`}
                    src={exportIcon}
                    alt="Export to excel"
                  />
                  <span className={styles.disableText} style={{ textTransform: "capitalize" }}>
                    Export
                  </span>
                </div>
              </ActionMenuButton>
            )
          )}

          {hasWriteAccess(activeUser, groupName) &&
          dataFieldName !== "groupParameters" &&
          //!groupfault &&
          groupAcess &&
          !isEditActive ? (
            <ActionMenuButton id="Add" onClick={onAddNewItemClick}>
              <div className={styles.withIcon}>
                <img className={styles.icon} src={add} alt="Add new item" />
                <span style={{ textTransform: "capitalize" }}>Add {itemName}</span>
              </div>
            </ActionMenuButton>
          ) : (
            <ActionMenuButton id="Add">
              <div className={styles.withIcon}>
                <img
                  className={`${styles.icon} ${styles.disableImg}`}
                  src={add}
                  alt="Add new item"
                />
                <span className={styles.disableText} style={{ textTransform: "capitalize" }}>
                  Add {itemName}
                </span>
              </div>
            </ActionMenuButton>
          )}
          {hasWriteAccess(activeUser, groupName) && dataFieldName === "ioBasicDataTypes" && (
            <ActionMenuButton
              id="EditDataSection"
              onClick={() => this.props.editActions.toggleChildView()}
            >
              <div className={styles.withIcon}>
                <img className={styles.icon} src={service} alt="Edit data section" />
                <span style={{ textTransform: "capitalize" }}>Edit data sections</span>
              </div>
            </ActionMenuButton>
          )}
          {hasWriteAccess(activeUser, groupName) && dataFieldName === "ioOptions" && (
            <ActionMenuButton
              id="EditOptionEnumType"
              onClick={() => this.props.editActions.toggleChildView()}
            >
              <div className={styles.withIcon}>
                <img className={styles.icon} src={service} alt="Edit Option EnumType" />
                <span style={{ textTransform: "capitalize" }}>Edit Option EnumType</span>
              </div>
            </ActionMenuButton>
          )}
        </div>
        {showTableSettings !== false && (
          <Popup
            trigger={
              <div className={styles.TableSettings}>
                <ActionMenuButton>
                  <div className={styles.withIcon}>
                    <img className={styles.icon} src={service} alt="Table settings" />
                    <span>Table Settings</span>
                  </div>
                </ActionMenuButton>
              </div>
            }
            wide="very"
            content={
              <div onClick={(e) => e.stopPropagation()}>
              <Grid centered={true} divided={true} columns={2}>
                <Grid.Column textAlign="left">
                  <GlobalTableSettings />
                </Grid.Column>
                <Grid.Column textAlign="left">
                  <Header as="h4">{subMenuRoute}</Header>
                  <Divider />
                  <ColumnSelection
                    columns={selectedColumns}
                    handleColumnSelection={(name, value) => {
                      this.props.columnActions.setHidingColumnStatus(
                        name,
                        value,
                        subMenuRoute as State.ColumnOptions
                      );
                    }}
                  />
                </Grid.Column>
              </Grid>
              </div>
            }
            on="click"
            position="bottom right"
            className="tableSettingspopup"
          />
        )}
      </div>
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterWithUserSelection(userFiltering: Filter[] | undefined, rows: any[]): any[] {
    if (!userFiltering || userFiltering.length === 0) {
      return rows;
    }
    const retval = rows.filter(
      row =>
        userFiltering?.every(filter => {
          const column: State.Column | undefined = this.props.columns[
            this.props.selectedColumnsName
          ].find((col: Column) => col.id === filter.id);
          const propertyPath = column?.ownAccessorName || "";
          const propertyPathArray = propertyPath.split(".").slice(1);
          const indexedValue = getIndexedValue(propertyPathArray, row);
          const rowValue =
            (indexedValue === null || indexedValue === undefined || typeof indexedValue === "object")
              ? column?.ownAccessor(row)
              : indexedValue;
          const included =
            filter.value === "all"
              ? true
              : (rowValue !== null && rowValue !== undefined) && !!filter.value
              ? column?.hasDropdownFiltering
                ? column?.isMultiValueDropdown
                  ? String(rowValue ?? "").split(", ").some((val: string) => val.trim() === String(filter.value ?? ""))
                  : String(rowValue ?? "") === String(filter.value ?? "")
                : searchMatchRule(rowValue.toString(), filter.value.toString())
              : false;
          return included;
        }, this),
      this
    );
    return retval;
  }
}

const mapStateToProps = (state: State.Root, ownProps: OwnProps) => ({
  columns: state.columns,
  pdApi: state.pdApi,
  mainState: state.main,
  isEditActive: isEditActiveSelector(state.editView),
  objectIdentifier: editedObjectIdentifierSelector(state.editView, ownProps.subMenuRoute),
  filterOptions: state.filterOptions
});

const mapDispatchToProps = (dispatch: Dispatch<ColumnActions | EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  columnActions: bindActionCreators({ ...columnActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionMenu);
